import styled from "styled-components";
import { DivContentPage } from "../../components/common/DivContentPage";

const DivMain = styled(DivContentPage)`
  displey: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  //border: 4px solid red;
  .containerLeft {
    width: 100%;
    .divHeader {
      margin: unset;
      display: flex;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: end;
      .divRate {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .divRateTitle {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          gap: 5px;
          background-color: black;
          color: white;
          font-size: 14px;
          font-weight: 700;
          padding: 3px 15px;
          border-radius: 10px 0px 0px 10px;
        }
        .divRateValue {
          display: flex;
          align-items: center;
          height: 100%;
          background-color: white;
          font-size: 14px;
          font-weight: 700;
          padding: 3px 15px;
          border-radius: 0px 10px 10px 0px;
        }
      }
    }
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 18px;
  width: 100%;
  height: 100%;
  padding: 12px 0px 0px 0px;
  .containerTable {
    .geofence-modal {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      width: 230px;
      /* text-sm */
    }

    .geofence-section {
      background-color: black;
      color: white;
      border-radius: 1.5rem;
      /* rounded-3xl */
      padding-top: 0.5rem;
      padding-bottom: 0.3rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      span {
        font-size: 14px;
        font-weight: 700;
      }
      p {
        font-size: 14px;
      }
    }

    .geofence-section-row {
      background-color: black;
      color: white;
      border-radius: 1.5rem;
      display: flex;
      gap: 0.5rem;
      align-items: center;
      justify-content: center;
      text-size: 14px;
    }

    .geofence-ubication {
      width: 140px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .geofence-footer {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      justify-content: space-around;
    }

    .geofence-extra-content {
      background-color: black;
      width: 3.5rem;
      /* w-14 */
      height: 2rem;
      /* h-8 */
      border-radius: 1rem;
      /* rounded-2xl */
    }

    .geofence-color-circle {
      background-color: black;
      border-radius: 9999px;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .geofence-color-box {
      width: 1.5rem;
      /* w-6 */
      height: 1.5rem;
      /* h-6 */
      padding: 0.25rem !important;
      border-radius: 9999px;
    }

    .geofence-button-edit {
      background-color: black;
      border-radius: 9999px;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      border: none;
      cursor: pointer;
    }

    .geofence-button-close {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 9999px;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      border: none;
      cursor: pointer;
    }
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 0px 10px 0px #0000001f;
    width: 100%;
    height: 100%;
    .containerHeaderTable {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .txtTitle {
        font-size: 20px;
        font-weight: 700;
      }
      .divButtons {
        display: flex;
        gap: 10px;
        flex-direction: row;
      }
    }
  }
`;

export default { DivMain, ContentContainer };
